import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { MicroLabel } from './micro-label';

/**
 * Every screen opens the same way: a sans H1 with a mono metadata line beneath it.
 * Keeping it in one component is what stops that subtitle drifting into sans on some screens.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  className
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <header className={cn('flex items-start justify-between gap-6', className)}>
      <div className="grid gap-2">
        <h1 className="text-[30px] leading-none font-medium tracking-tight text-foreground">{title}</h1>
        {subtitle ? <MicroLabel>{subtitle}</MicroLabel> : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </header>
  );
}
